import styled from 'styled-components';

export const UserNameContainer = styled.small`
  display: inline-block;
  margin-right: 12px;
`;
